module.exports = __webpack_public_path__ + "media/application/images/2018/popup-close-8401a0a81ca400368342d41e61c20ffe.svg";